export default __webpack_public_path__ + "static/media/38.44458a88.jpg";